import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

export const TextMarkup = ({
    elementType = 'div',
    fontFamily = 'body',
    textMarkup,
    textColor = 'inherit',
    heading,
    headingTag,
    headingFontFamily,
    contentWidth
}) => {
    if (!textMarkup && !heading) {
        return null
    }
    const headerFontSize =
        headingTag === 'h1' ? {base: '27px', lg: '32px'} : {base: '24px', lg: '28px'}
    const isContentCentered = contentWidth === 'centered'
    return (
        <Box
            as={elementType}
            color={textColor}
            marginBottom="15px"
            fontFamily={fontFamily}
            margin={isContentCentered ? {base: '0 15px', lg: '0 90px'} : '0 15px'}
            letterSpacing="0.16px"
            sx={{
                p: {
                    fontSize: '16px',
                    color: 'black',
                    fontFamily: 'body',
                    lineHeight: '25px',
                    letterSpacing: '0.08px',
                    marginBottom: '15px'
                },
                a: {
                    textDecoration: 'underline',
                    color: 'black'
                },
                'a:hover': {
                    textDecoration: 'none'
                }
            }}
        >
            {heading && (
                <Text
                    as={headingTag || 'h2'}
                    fontFamily={headingFontFamily || fontFamily}
                    fontSize={headerFontSize}
                    color="black.100"
                    marginBottom="20px"
                >
                    {heading}
                </Text>
            )}
            {textMarkup ? <Text dangerouslySetInnerHTML={{__html: textMarkup}} /> : null}
        </Box>
    )
}

TextMarkup.propTypes = {
    elementType: PropTypes.elementType,
    fontFamily: PropTypes.string,
    textMarkup: PropTypes.string,
    textColor: PropTypes.string,
    heading: PropTypes.string,
    headingTag: PropTypes.string,
    headingFontFamily: PropTypes.string,
    contentWidth: PropTypes.string
}

export default TextMarkup
